import React from 'react';
import './InitiativeInterceptionButtonCompact.css';
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from '../../../gameUi/GameButton';

const InitiativeInterceptionButtonCompact = (
  {
    isActive,
    isInitiativeOwner,
    isDisabled,
    handleClick,
  }
) => {
  // Если мы уже являемся владельцем инициативы показываем соответствующую иконку
  if (isInitiativeOwner) {
    return (
      <GameButton
        variant={GAME_BUTTON_VARIANTS.SUNK}
        size={GAME_BUTTON_SIZES.ICON}
        onClick={handleClick}
        data-tutorial-select={'initiative_interception'}
        className={'footer-heading-btn'}
        title="Инициатива (право первого хода в фазе)"
      >
        <img
          src={'/img/icons/initiative.png'}
          alt={'Initiative owner'}
        />
      </GameButton>
    );
  }

  return (
    <GameButton
      variant={GAME_BUTTON_VARIANTS.SUNK}
      size={GAME_BUTTON_SIZES.ICON}
      onClick={handleClick}
      data-tutorial-select={'initiative_interception'}
      className={`footer-heading-btn ${isActive ? 'icon-button-active' : ''}`}
      title={isActive ? 'Отменить перехват инициативы' : 'Перехватить инициативу'}
      style={{
        opacity: isDisabled ? 0.3 : 1,
      }}
    >
      <img
        src={isActive
          ? '/img/icons/action initiative active.png'
          : '/img/icons/action initiative not active.png'
        }
        alt={'Initiative interception'}
      />
    </GameButton>
  );
};

export default InitiativeInterceptionButtonCompact;
